<script>
  import { DataInventoryServiceIdToName, getSlaMarketDayOffsetLabel } from '../../../shared/constants';

  export let eventData;

  const serviceName = (serviceId) => DataInventoryServiceIdToName[serviceId] ?? serviceId;
</script>

{#if eventData.added?.length}
  <h6 class="key-heading">Added:</h6>
  {#each eventData.added as { feedId, serviceId, marketDayOffset }}
    <span class="association-entry">
      {feedId} — {serviceName(serviceId)}
      {#if marketDayOffset}
        <strong>({getSlaMarketDayOffsetLabel(marketDayOffset)})</strong>
      {/if}
    </span>
  {/each}
{/if}
{#if eventData.removed?.length}
  <h6 class="key-heading">Removed:</h6>
  {#each eventData.removed as { feedId, serviceId, marketDayOffset }}
    <span class="association-entry">
      {feedId} — {serviceName(serviceId)}
      {#if marketDayOffset}
        <strong>({getSlaMarketDayOffsetLabel(marketDayOffset)})</strong>
      {/if}
    </span>
  {/each}
{/if}
{#if eventData.changed?.length}
  <h6 class="key-heading">Changed:</h6>
  {#each eventData.changed as { feedId, serviceId, previousMarketDayOffset, marketDayOffset }}
    <span class="association-entry">
      {feedId} — {serviceName(serviceId)}
      <strong>({getSlaMarketDayOffsetLabel(previousMarketDayOffset)} → {getSlaMarketDayOffsetLabel(marketDayOffset)})</strong>
    </span>
  {/each}
{/if}

<style>
  .association-entry {
    display: block;
    margin-bottom: 0.5rem;
  }
</style>
